<template>
  <div class="regional-chart-container">
    <div class="filters">
      <select
        v-model="selectedState"
        class="filter-select"
      >
        <option value="">
          Todos os Estados
        </option>
        <option
          v-for="state in uniqueStates"
          :key="state"
          :value="state"
        >
          {{ state }}
        </option>
      </select>

      <select
        v-model="selectedType"
        class="filter-select"
      >
        <option value="">
          Todos os Tipos
        </option>
        <option
          v-for="type in uniqueBiddingTypes"
          :key="type"
          :value="type"
        >
          {{ type }}
        </option>
      </select>

      <input
        v-model="startDate"
        type="date"
        class="filter-select"
      >
      <input
        v-model="endDate"
        type="date"
        class="filter-select"
      >
    </div>

    <div class="chart-box">
      <bar-chart-base
        :key="chartKey"
        :chart-data="chartData"
        :options="chartOptions"
      />
    </div>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import { reactiveProp } from 'vue-chartjs/es/mixins'
import fetchRegionalBiddingData from '@/syslic/dashboard/regionalBidding/regionalBiddingService'
import filterRegionalBiddingDataFromApi from '@/syslic/dashboard/regionalBidding/regionalBiddingFilter'

const BarChartBase = {
  extends: Bar,
  mixins: [reactiveProp],
  props: ['chartData', 'options'],
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    chartData(newData) {
      this.renderChart(newData, this.options)
    },
  },
}

export default {
  name: 'RegionalBiddingChart',
  components: {
    BarChartBase,
  },
  data() {
    return {
      rawData: [],
      selectedState: '',
      selectedType: '',
      startDate: '',
      endDate: '',
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'top',
          },
          title: {
            display: true,
            text: 'Desempenho Regional por Estado',
          },
          tooltip: {
            callbacks: {
              label: context => {
                const { dataset, dataIndex } = context
                return `${dataset.label}: ${dataset.data[dataIndex]}`
              },
            },
          },
        },
      },
    }
  },
  computed: {
    chartKey() {
      return `${this.selectedState}-${this.selectedType}-${this.startDate}-${this.endDate}`
    },
    chartData() {
      return filterRegionalBiddingDataFromApi(this.rawData, {
        state: this.selectedState,
        biddingType: this.selectedType,
        startDate: this.startDate,
        endDate: this.endDate,
      })
    },
    uniqueStates() {
      const states = new Set()
      this.rawData.forEach(item => {
        if (item.stateName) states.add(item.stateName)
      })
      return Array.from(states).sort()
    },
    uniqueBiddingTypes() {
      const types = new Set()
      this.rawData.forEach(item => {
        if (item.biddingType) types.add(item.biddingType)
      })
      return Array.from(types).sort()
    },
  },
  async mounted() {
    const response = await fetchRegionalBiddingData(this)
    this.rawData = Array.isArray(response) ? response : []
  },
}
</script>

<style scoped>
.regional-chart-container {
  height: 100%;
}

.filters {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
}

.filter-select {
  padding: 0.5rem;
  font-size: 1rem;
  border-radius: 0.25rem;
  border: 1px solid #ccc;
}

.chart-box {
  width: 100%;
  height: 400px;
}
</style>
